import * as React from 'react';
import styled from 'styled-components';

import { Table } from 'components/bootstrap';
import { PaginatedList, Spinner } from 'components/common';
import { usePagination, useSetPagination } from 'common/contexts';
import { useGetEventProcedureSteps } from 'security-app/hooks/useEventProceduresAPI';
import EventProcedureTabs from 'security-app/components/SecurityEvents/EventProcedures/EventProcedureTabs';

import ListHeader from './ListHeader';
import ListRows from './ListRows';

const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
  width: 200px;
`;

type Props = {
  useCoreRoutes?: boolean;
};

function StepsList({ useCoreRoutes = false }: Props) {
  const localPagination = usePagination();
  const setLocalPagination = useSetPagination();

  const { eventProcedureSteps, loadingEventProcedureSteps, pagination } = useGetEventProcedureSteps(localPagination);

  const onPageChange = (newPage: number, newPageSize: number) => {
    setLocalPagination({ ...localPagination, page: newPage, perPage: newPageSize });
  };

  return (
    <PaginatedList
      activePage={localPagination.page}
      pageSize={localPagination.perPage}
      onChange={onPageChange}
      totalItems={pagination.total}
      useQueryParameter={false}>
      <TabsContainer>
        <EventProcedureTabs viewType="steps" useCoreRoutes={useCoreRoutes} />
      </TabsContainer>
      <Table condensed hover className="table table-striped" data-testid="event-procedure-steps-list">
        <ListHeader />
        <tbody>
          {loadingEventProcedureSteps ? (
            <tr>
              <td colSpan={4} aria-label="Loading Event Procedures Steps">
                <Spinner text="Loading Event Procedures Steps ..." />
              </td>
            </tr>
          ) : (
            <ListRows eventProcedureSteps={eventProcedureSteps} />
          )}
        </tbody>
      </Table>
    </PaginatedList>
  );
}

export default StepsList;
